export default defineNuxtPlugin(() => {
  if (process.client) {
    // const scriptJQuery = document.createElement('script')
    // scriptJQuery.src = 'https://imgf1.fccs.com.cn/newhouse/m_v2/js/jquery-1.9.1.min.js?20240222'
    // scriptJQuery.async = true
    // document.head.appendChild(scriptJQuery)

    const scriptRightFixedMenu = document.createElement('script')
    scriptRightFixedMenu.src = 'https://imgf1.fccs.com.cn/public/rightfixedmenu/v2/js/rightfixedmenu.js?20240222'
    scriptRightFixedMenu.async = true
    document.head.appendChild(scriptRightFixedMenu)

    const linkCSS = document.createElement('link')
    linkCSS.rel = 'stylesheet'
    linkCSS.href = 'https://imgf1.fccs.com.cn/public/rightfixedmenu/v2/css/rightfixedmenu.css'
    document.head.appendChild(linkCSS)
  }
})
